import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { ServiceRequestList } from '@/components/service-requests/request-list';
import { ServiceRequestForm } from '@/components/service-requests/request-form';
import { ServiceRequestDetails } from '@/components/service-requests/request-details';
import { useToast } from '@/hooks/use-toast';
// @ts-ignore - TODO: Fix this TypeScript error
import type { ServiceRequest } from '@/lib/types';

type View = 'list' | 'form' | 'details';

export function ServiceRequestsPage() {
  const [view, setView] = useState<View>('list');
  const [selectedRequest, setSelectedRequest] = useState<ServiceRequest | null>(null);
  const { toast } = useToast();

  const handleCreateRequest = async (data: any) => {
    try {
      // Here you would make an API call to create the request
      console.log('Creating service request:', data);
      
      toast({
        title: 'Success',
        description: 'Service request created successfully',
      });
      setView('list');
    } catch (error) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Failed to create service request',
      });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">
          {view === 'list' && 'Service Requests'}
          {view === 'form' && 'Create Service Request'}
          {view === 'details' && 'Request Details'}
        </h1>
        <div className="flex gap-2">
          {view !== 'list' && (
            <Button
              variant="outline"
              onClick={() => {
                setView('list');
                setSelectedRequest(null);
              }}
            >
              Back to List
            </Button>
          )}
          {view === 'list' && (
            <Button onClick={() => setView('form')}>
              <Plus className="mr-2 h-4 w-4" />
              Create Request
            </Button>
          )}
        </div>
      </div>

      {view === 'list' && (
        <ServiceRequestList
          onRequestClick={(request) => {
            setSelectedRequest(request);
            setView('details');
          }}
        />
      )}

      {view === 'form' && (
        <ServiceRequestForm
          onSubmit={handleCreateRequest}
        />
      )}

      {view === 'details' && selectedRequest && (
        <ServiceRequestDetails
          request={selectedRequest}
          onEdit={() => setView('form')}
        />
      )}
    </div>
  );
}